import { cn } from '../../../lib/cn'

export interface DotsCenterProps {
  className?: string
}

/**
 * DotsCenter - Dot pattern background with center fade
 *
 * Creates a repeating dot pattern that fades from the center.
 * Uses theme variables for automatic light/dark mode support.
 *
 * Fixed fadeSize: 0.6
 *
 * @example
 * ```tsx
 * <section className="relative">
 *   <DotsCenter />
 *   <div className="relative z-10">Content here</div>
 * </section>
 * ```
 */
export function DotsCenter({ className }: DotsCenterProps = {}) {
  const fadeSize = 0.6
  const size = `${fadeSize * 100}%`
  const maskGradient = `radial-gradient(ellipse ${size} ${size} at 50% 50%, #000 40%, transparent 100%)`

  return (
    <div
      className={cn('absolute inset-0 z-0', className)}
      style={{
        backgroundImage: `radial-gradient(circle, var(--border) 1px, transparent 1px)`,
        backgroundSize: '24px 24px',
        maskImage: maskGradient,
        WebkitMaskImage: maskGradient,
      }}
    />
  )
}
